import { STATUS_BOOKED, TEACHER_ROLE } from "../constants";
import ZoomIcon from "../assets/images/zoom.png";
import { toast } from "react-toastify";
import { firestore } from "../firebase/config";
import { baseUrl } from "../services/api";
import moment from "moment";
import { addofferSlotIdOnMeetingLink } from "../services/offer-slots";

import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

export const getFormattedTime = (timestamp) => {
  const date = new Date(timestamp * 1000); // Convert to milliseconds

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12; // Convert 0 to 12 for noon/midnight

  // return `${year}-${month}-${day} ${formattedHours}:${
  //   minutes < 10 ? "0" : ""
  // }${minutes} ${ampm}`;
  return `${formattedHours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
};

export const formatMessage = (message, maxWordsPerLine) => {
  const words = message?.split(" ");
  const lines = [];

  while (words?.length > 0) {
    lines.push(words?.splice(0, maxWordsPerLine)?.join(" "));
  }

  return lines?.join("\n");
};

/**
 * clear local storage
 */
export const clearLocalStorage = () => {
  window.localStorage.clear();
  window.location.href = "/";
};

export const convertTo12HourFormat = (time24) => {
  // Split the input time into hours, minutes, and seconds
  const [hour, minutes] = time24?.split(":").map(Number);

  // Determine if it's AM or PM
  const period = hour >= 12 ? "PM" : "AM";

  // Convert to 12-hour format
  let hour12 = hour % 12;
  if (hour12 === 0) {
    hour12 = 12; // 0 in 24-hour format is 12 in 12-hour format
  }

  // Create the formatted time string without seconds
  const time12 = `${hour12}:${String(minutes).padStart(2, "0")} ${period}`;

  return time12;
};

export const formatDate = (inputDate) => {
  // Convert input string to a Date object
  var dateObj = new Date(inputDate);

  // Define an array to store day names and month names
  var dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  var monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract day, month, and year from the Date object
  var dayName = dayNames[dateObj.getDay()];
  var monthName = monthNames[dateObj.getMonth()];
  var day = dateObj.getDate();
  var year = dateObj.getFullYear();

  // Create the formatted date string
  var formattedDate =
    dayName +
    ", " +
    monthName +
    " " +
    (day < 10 ? "0" : "") +
    day +
    ", " +
    year;

  return formattedDate;
};

// Iterate through the slots and update the status if the start time has passed
export const updateSlotStatusToExpire = (slots, currDay) => {
  const currentDay = new Date().toLocaleDateString("en-US", {
    weekday: "long",
  });
  const currentTime = new Date()
    .toLocaleTimeString("en-US", { hour12: false })
    .slice(0, 5); // Remove seconds

  const updatedSlots = slots.map((slot) => {
    if (
      currDay === currentDay &&
      slot?.status !== STATUS_BOOKED &&
      slot?.startTime < currentTime
    ) {
      slot.status = "expire";
    }
    return slot;
  });

  return updatedSlots;
};

export const formatChatDate = (dateString) => {
  const dateObj = new Date(dateString);

  // Define an array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Get the month name, date, and year components
  const monthName = monthNames[dateObj.getMonth()];
  const date = dateObj.getDate();
  // const year = dateObj.getFullYear();
  const year = dateObj.getFullYear().toString().slice(-2);

  // Format the date string
  const formattedDate = `${date}-${monthName}-${year}`;

  return formattedDate;
};

const handleSlotIdSend = async (offerSlotId, role) => {
  try {
    let payload = {};
    if (role === TEACHER_ROLE) {
      payload.teacherClickedMeeting = true;
      payload.teacherMeetingClickedDateTime = new Date();
    } else {
      payload.studentClickedMeeting = true;
      payload.studentMeetingClickedDateTime = new Date();
    }

    let { status, data } = await addofferSlotIdOnMeetingLink(
      offerSlotId,
      payload
    );
    if (status === 200) {
      console.log("data", data);
    } else {
      reactToast("error", "Something went wrong!");
    }
  } catch (error) {
    reactToast("error", "Something went wrong!");
  }
};

window.handleJoinNow = (url, offerSlotId, role) => {
  console.log("offerSlotId", offerSlotId);
  handleSlotIdSend(offerSlotId, role);
  window.open(url, "_blank");
};

// This function finds and replaces URLs with anchor tags
export const makeLinksClickable = (text, message, role) => {
  console.log(" makeLinksClickable message", message, role);
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  // return text.replace(urlRegex, (url) => {
  //   return `<a class="text-${color} fs_12" href="${url}" target="_blank">${url}</a>`;
  // });

  // return text?.replace(urlRegex, (url) => {
  //   return `
  //     <div class="pe-3 pt-2">
  //     <div class="d-flex">
  //     <img src="${ZoomIcon}" style="height: 28px;" alt="Zoom Image" class="zoom-image" />
  //     <div>
  //     <span class="d-flex font-size-13px">Let's meet up now</span>
  //     <span class="d-flex font-size-13px">The meeting will be recorded.</span>
  //     </div>
  //     </div>
  //     <div class="d-flex justify-content-end mt-2">
  //     <button class="btn btn-primary fs_12" onclick="window.open('${url}', '_blank')">Join Now</button>
  //     </div>
  //     </div>
  //   `;
  // });

  return text?.replace(urlRegex, (url) => {
    return `
      <div class="pe-3 pt-2">
      <div class="d-flex">
      <img src="${ZoomIcon}" style="height: 28px;" alt="Zoom Image" class="zoom-image" />
      <div>
      <span class="d-flex font-size-13px">Let's meet up now</span>
      <span class="d-flex font-size-13px">The meeting will be recorded.</span>
      </div>
      </div>
      <div class="d-flex justify-content-end mt-2">
      <button class="btn btn-primary fs_12" onclick="window.handleJoinNow('${url}', '${message?.offerSlotId}', '${role}')">Join Now</button>
      </div>
      </div>
    `;
  });
};

export const reactToast = (type, text) => {
  toast[type || "success"](text);
};

export const getErrorMessages = (errors) => {
  let errorMessages = {};

  errors?.inner?.forEach((err) => {
    errorMessages[err.path] = err.message;
  });
  return errorMessages;
};

export const extractHoursAndMinutes = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure 2-digit format
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // Convert 24-hour format to 12-hour format

  return `${formattedHours}:${minutes} ${ampm}`;
};

export const getLastDayOfMonth = () => {
  // Get today's date
  const today = new Date();

  // Get the current month and year
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();

  // Calculate the last day of the month
  const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0);

  // Format the last day of the month as YYYY-MM-DD
  const formattedLastDayOfMonth = `${lastDayOfMonth.getFullYear()}-${(
    lastDayOfMonth.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${lastDayOfMonth.getDate().toString().padStart(2, "0")}`;

  return formattedLastDayOfMonth;
};

export const getTodayDate = () => {
  // Get today's date
  const today = new Date();

  // Get the year, month, and day
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, "0"); // Add 1 to month since it's zero-based
  const day = today.getDate().toString().padStart(2, "0");

  // Format the date as "YYYY-MM-DD"
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

export const formatEventData = (data) => {
  const events = data.map((item) => ({
    ...item,
    id: item.id,
    start: new Date(item.date + "T" + item.startTime), // Combine date and start time
    end: new Date(item.date + "T" + item.endTime), // Combine date and end time
    title: item.student.fullName, // Use student's full name as title
  }));
  return events;
};

export const getMonthStartEndDates = (date) => {
  // // Get the year and month from the given date
  // const year = date.getFullYear();
  // const month = date.getMonth();

  // // Calculate the start date of the month
  // const startDate = new Date(year, month, 1).toISOString().slice(0, 10);

  // // Calculate the end date of the month
  // const endDate = new Date(year, month + 1, 0).toISOString().slice(0, 10);
  // return { startDate, endDate };

  const startDate = moment().startOf("month").format("YYYY-MM-DD");
  const endDate = moment().endOf("month").format("YYYY-MM-DD");

  return { startDate, endDate };
};

export const formatStudentEventData = (data) => {
  const events = data.map((item) => ({
    ...item,
    id: item.id,
    start: new Date(item.date + "T" + item.startTime), // Combine date and start time
    end: new Date(item.date + "T" + item.endTime), // Combine date and end time
    title: item?.teacher?.fullName, // Use student's full name as title
  }));
  return events;
};

export const getLesserID = (senderId, receiverId) => {
  return senderId < receiverId ? senderId : receiverId;
};

export const getGreaterID = (senderId, receiverId) => {
  return senderId < receiverId ? receiverId : senderId;
};

export const addDocToFirestore = async (senderId, receiverId, messageBody) => {
  // Step 1: Identify the chat document or create a new one
  const chatID = `${getLesserID(senderId, receiverId)}_${getGreaterID(
    senderId,
    receiverId
  )}`;
  const chatRef = firestore.collection("chats").doc(chatID);
  const chatDoc = await chatRef.get();

  if (!chatDoc.exists) {
    // Create a new chat document if it doesn't exist
    await chatRef.set({
      sender_uuid: senderId,
      receiver_uuid: receiverId,
      lastMessage: messageBody,
    });
  } else {
    // Update the lastMessage field in the existing chat document
    await chatRef.update({
      lastMessage: messageBody,
    });
  }

  // Step 2: Add a new document to the messages subcollection
  await chatRef.collection("messages").add(messageBody);
};

export const uploadAudioToFirebase = async (audioBlob) => {
  const storage = getStorage();
  const audioRef = ref(storage, `audio/${new Date().getTime()}.wav`); // unique timestamp

  try {
    await uploadBytes(audioRef, audioBlob);

    const audioUrl = await getDownloadURL(audioRef);
    console.log("Audio uploaded successfully, URL: ", audioUrl);
    return audioUrl;
  } catch (error) {
    console.error("Error uploading audio to Firebase: ", error);
    return null;
  }
};

export const getStudentChatDataForUserWithLastMessage = async (
  userId,
  callback
) => {
  try {
    const unsubscribeReceiver = firestore
      .collection("chats")
      .where("receiver_uuid", "==", userId)
      .onSnapshot((receiverSnapshot) => {
        const receiverChats = receiverSnapshot.docs.map((doc) => ({
          chatId: doc.id,
          lastMessage: doc.data().lastMessage,
        }));
        callback(receiverChats);
        // setMessageSeen(false);
        // setMessageLoading(false);
      });
    const unsubscribeSender = firestore
      .collection("chats")
      .where("sender_uuid", "==", userId)
      .onSnapshot((senderSnapshot) => {
        const senderChats = senderSnapshot.docs.map((doc) => ({
          chatId: doc.id,
          lastMessage: doc.data().lastMessage,
        }));
        callback(senderChats);
        // setMessageSeen(false);
        // setMessageLoading(false);
      });

    // Returning the unsubscribe functions in case you want to stop listening to changes later
    return {
      unsubscribeSender,
      unsubscribeReceiver,
    };
  } catch (error) {
    console.error("Error getting chat data for user:", error);
    throw error;
  }
};

export const getTeahcherChatDataForUserWithLastMessage = async (
  userId,
  callback
) => {
  try {
    const unsubscribeSender = firestore
      .collection("chats")
      .where("sender_uuid", "==", userId)
      .onSnapshot((senderSnapshot) => {
        const senderChats = senderSnapshot.docs.map((doc) => ({
          chatId: doc.id,
          lastMessage: doc.data().lastMessage,
        }));
        callback(senderChats);
      });
    const unsubscribeReceiver = firestore
      .collection("chats")
      .where("receiver_uuid", "==", userId)
      .onSnapshot((receiverSnapshot) => {
        const receiverChats = receiverSnapshot.docs.map((doc) => ({
          chatId: doc.id,
          lastMessage: doc.data().lastMessage,
        }));
        callback(receiverChats);
      });

    // Returning the unsubscribe functions in case you want to stop listening to changes later
    return {
      unsubscribeSender,
      unsubscribeReceiver,
    };
  } catch (error) {
    console.error("Error getting chat data for user:", error);
    throw error;
  }
};

export const filterProfilePicture = (list) => {
  if (list?.length) {
    let profilePicture = list?.find((item) => item?.type === "profilePicture");
    console.log("URL PICTURE",`${baseUrl}${profilePicture?.url}`)
    if (profilePicture) {
      return `${baseUrl}${profilePicture?.url}`;
    }
  }
};

export const containsLink = (text) => {
  const urlRegex = /https?:\/\/[^\s/$.?#].[^\s]*/i;
  return urlRegex.test(text);
};

export const getDocumentUrls = (documents, type, name = "") => {
  let filterDocuments = [];
  if (type && documents?.length) {
    filterDocuments = documents?.filter((item) => item?.type === type);
  }
  return filterDocuments;
};

export const groupSlotsByDate = (slots) => {
  const groupedSlots = {};

  // Sort slots by date
  slots?.sort((a, b) => new Date(a.date) - new Date(b.date));

  slots?.forEach((slot) => {
    const date = slot.date;
    if (!groupedSlots[date]) {
      groupedSlots[date] = [];
    }
    groupedSlots[date].push(slot);
  });

  return groupedSlots;
};
